module.exports = __webpack_public_path__ + "static/banner_cpa_2026-616c3f737e6d9eea60c8f0d4e571edd4.png";